import mod from "-!../../cache-loader/dist/cjs.js!../../buble-loader/index.js??ref--2-1!../../vue-loader/lib/index.js??vue-loader-options!./BounceLoader.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../cache-loader/dist/cjs.js!../../buble-loader/index.js??ref--2-1!../../vue-loader/lib/index.js??vue-loader-options!./BounceLoader.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-spinner/src/BounceLoader.vue?vue&type=script&lang=js&
// module id = 199
// module chunks = 0